<template>
    <main class="form-page text-center d-flex justify-content-center align-items-center">
        <div class="card card-small-box reset-card">
            <div class="w-100 d-flex justify-content-center mb-4">
                <BrandLogo variant="vector" alt="Greenwood Aerospace" class="logo-size" />
            </div>
            <h2>Reset Your Password</h2>
            <div v-if="success" class="alert alert-success mt-3 mb-0">
                <p>Password changed successfully.</p>
                <p>You can now close this window and log in with your new password.</p>
                <p>
                    <a href="/">Log in</a>
                </p>
            </div>
            <div v-if="errors.length" class="alert alert-danger mt-3 mb-0">
                <ul>
                    <li v-for="(error, idx) in errors" :key="idx">{{ error }}</li>
                </ul>
            </div>
            <form @submit.prevent="handleSubmit" class="mt-4 mb-0">
                <div class="mb-3">
                    <label for="newPassword" class="form-label">New Password</label>
                    <input
                        type="password"
                        id="newPassword"
                        v-model="new_password"
                        class="form-control"
                        required
                        autocomplete="new-password"
                        :disabled="loading || success"
                    />
                </div>
                <div class="mb-3">
                    <label for="confirmNewPassword" class="form-label">
                        Confirm New Password
                    </label>
                    <input
                        type="password"
                        id="confirmNewPassword"
                        v-model="confirm_new_password"
                        class="form-control"
                        required
                        autocomplete="new-password"
                        :disabled="loading || success"
                    />
                </div>
                <button
                    type="submit"
                    class="btn btn-primary w-100 d-inline-flex align-items-center justify-content-center gap-2"
                    :disabled="loading || success"
                >
                    <span
                        v-if="loading"
                        class="spinner-border spinner-border-sm text-light"
                        role="status"
                        aria-hidden="true"
                    ></span>
                    {{ loading ? 'Changing...' : 'Change Password' }}
                </button>
            </form>
        </div>
    </main>
</template>

<script>
import { CHANGE_PASSWORD } from '@/data/url'
import BrandLogo from '@/components/shared/BrandLogo.vue'

export default {
  name: 'ChangePasswordPage',
  components: { BrandLogo },
  data() {
    return {
      backendURL: process.env.VUE_APP_BACKEND_URL,
      new_password: '',
      confirm_new_password: '',
      errors: [],
      loading: false,
      success: false,
    }
  },
  methods: {
    async handleSubmit() {
      if (this.loading || this.success) {
        return
      }

      this.errors = []
      this.success = false

      // Passwords match validation
      if (this.new_password !== this.confirm_new_password) {
        this.errors.push('New password and confirmation do not match.')
        return
      }

      this.loading = true
      const { uid, token } = this.$route.params
      const url = this.backendURL + CHANGE_PASSWORD

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            new_password: this.new_password,
            confirm_password: this.confirm_new_password,
            uid,
            token,
          }),
        })

        const data = await response.json()

        if (response.ok && data.status) {
          this.success = true
          this.new_password = ''
          this.confirm_new_password = ''
        } else {
          if (data.error) {
            this.errors.push(data.error)
          } else if (data.errors) {
            this.errors = this.errors.concat(data.errors)
          } else {
            this.errors.push('Failed to change password. Please try again.')
          }
        }
      } catch (err) {
        this.errors.push('Network error. Please try again.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
    .card-small-box {
        max-width: 400px;
        margin: 0 auto;
        padding-bottom: 1.5rem !important;
    }

    .form-signin {
        padding: 0 !important;
    }

    .logo-size {
        height: auto;
        max-width: 50%;
    }
</style>
